<template>
    <div class="add_institution py-4 min-vh-100 align-content-center">
        <div class="row justify-content-center">
            <div class="col-12 col-md-10 col-lg-8 col-xxl-6">
                <div class="w-100 inner">
                    <div class="">
                        <h1 class="text-center company_name">{{ $t("titles.companyName") }}</h1>
                    </div>
                    <div class="d-flex flex-wrap justify-content-between mt-4">
                        <h2 class="login_title">{{ $t("institution.register.title") }}</h2>
                    </div>
                    <div v-if="invalid" class="alert alert-danger mt-3 mb-1" role="alert">
                        {{ invalid }}
                    </div>
                    <!-- Loading after clicking register button -->
                    <div v-if="loading" class="text-center mt-2">
                        <p>{{ $t("general.loading") }}</p>
                        <div class="spinner-border" role="status">
                        </div>
                    </div>

                    <!-- Company Name -->
                    <div class="d-flex input_group mt-3"
                        :class="{ active: activeInput === 'company_name' || formData.company_name }">
                        <label for="company_name" class="py-3 ms-4 me-2">
                            {{ $t("institution.register.name") }}:
                        </label>
                        <input type="text" ref="company_name" v-model="formData.company_name"
                            :placeholder="$t('institution.register.name')" @focus="activateInput('company_name')"
                            @blur="deactivateInput()">
                    </div>

                    <!-- Email -->
                    <div class="d-flex input_group mt-3"
                        :class="{ active: activeInput === 'billing_email' || formData.billing_email }">
                        <label for="billing_email" class="py-3 ms-4 me-2">
                            {{ $t("institution.register.billingMail") }}:
                        </label>
                        <input type="text" ref="billing_email" v-model="formData.billing_email"
                            :placeholder="$t('institution.register.billingMail')"
                            @focus="activateInput('billing_email')" @blur="deactivateInput()">
                    </div>

                    <!-- ICO -->
                    <div class="d-flex input_group mt-3" :class="{ active: activeInput === 'ico' || formData.ico }">
                        <label for="ico" class="py-3 ms-4 me-2">
                            {{ $t("institution.register.organization_id") }}:
                        </label>
                        <input type="number" ref="ico" v-model="formData.ico"
                            :placeholder="$t('institution.register.organization_id')" @focus="activateInput('ico')"
                            @blur="deactivateInput()">
                    </div>

                    <!-- DIC -->
                    <div class="d-flex input_group mt-3" :class="{ active: activeInput === 'dic' || formData.dic }">
                        <label for="dic" class="py-3 ms-4 me-2">
                            {{ $t("institution.register.dic") }} ({{ $t("general.optional") }}):
                        </label>
                        <input type="number" ref="dic" v-model="formData.dic"
                            :placeholder="$t('institution.register.dic')" @focus="activateInput('dic')"
                            @blur="deactivateInput()">
                    </div>

                    <!-- Residence -->
                    <div class="d-flex input_group mt-3"
                        :class="{ active: activeInput === 'residence' || formData.residence }">
                        <label for="residence" class="py-3 ms-4 me-2">
                            {{ $t("institution.register.residence") }}:
                        </label>
                        <input type="text" ref="residence" v-model="formData.residence"
                            :placeholder="$t('institution.register.residence')" @focus="activateInput('residence')"
                            @blur="deactivateInput()">
                    </div>

                    <div class="checkbox_group mt-3">
                        <div class="form-check">
                            <input type="checkbox" class="me-2 form-check-input checkbox" ref="checkbox"
                                v-model="formData.PersonalDataCheck">
                            <label for="personalDataCheck" class="form-check-label pt-1">
                                <a href="/gdpr" target="_blank">
                                    {{ $t("register.protectionOfPersonalData") }}
                                </a>
                            </label>
                        </div>
                        <div class="form-check mt-1">
                            <input type="checkbox" class="me-2 form-check-input checkbox" ref="checkbox"
                                v-model="formData.termsAndConditions">
                            <label class="form-check-label pt-1">
                                <a href="/terms" target="_blank">
                                    {{ $t("register.termsAndConditions") }}
                                </a>
                            </label>
                        </div>
                    </div>
                </div>
                <div v-if="!loading" class="text-center">
                    <button type="submit" class="btn btn_submit" @click="register()">
                        <span>{{ $t("institution.register.button") }}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            formData: {
                company_name: "",
                ico: "",
                dic: "",
                residence: "",
                PersonalDataCheck: false,
                termsAndConditions: false,
            },
            invalid: false,
            loading: false,
            activeInput: null
        }
    },
    methods: {
        register: function () {
            this.invalid = false
            this.loading = true;
            this.$store.getters.api.post("/institution/register", this.formData)
                .then(
                    (response) => {
                        this.loading = false;
                        const data = response.data;
                        if (data.error_code == 108) {
                            this.invalid = (this.$t("error.108"));
                            this.$refs.company_name.setCustomValidity(this.$t("error.108"));
                            this.$refs.company_name.reportValidity();
                        }
                        else if (data.error_code == 109) {
                            this.invalid = (this.$t("error.109"));
                            this.$refs.ico.setCustomValidity(this.$t("error.108"));
                            this.$refs.ico.reportValidity();
                        }
                        else if (data.error_code == 111) {
                            this.invalid = (this.$t("error.111"));
                            this.$refs.residence.setCustomValidity(this.$t("error.111"));
                            this.$refs.residence.reportValidity();
                        }
                        else if (data.error_code == 113) {
                            this.invalid = (this.$t("error.113"));
                        }
                        else if (data.error_code == 114) {
                            this.invalid = (this.$t("error.114"));
                        }
                        else if (data.error_code == 115) {
                            this.invalid = (this.$t("error.115"));
                        }
                        else if (data.error_code == 116) {
                            this.invalid = (this.$t("error.116"));
                        }
                        else {
                            window.location.reload()
                        }
                    }
                )
        },
        activateInput(inputId) {
            this.activeInput = inputId;
        },
        deactivateInput() {
            this.activeInput = null;
        }
    },
}
</script>

<style scoped lang="scss">
@import "@/scss/abstracts/variables";
@import "@/scss/base/typography.scss";

.inner {
    background: radial-gradient(circle, $light-purple 6%, $purple 100%);
    border-radius: $radius-xl;
    box-shadow: $shadow-lg;
    padding: clamp(20px, 4vw, 35px);
    margin: 0 0 20px 0;
}

.company_name {
    font-family: "Outfit";
    font-weight: 800;
    font-size: clamp(40px, 9vw, 66px);
    line-height: 1.1;
    text-shadow: 5px 5px 10px $black;
    color: $white;
    word-break: break-word;
}

.login_title {
    color: $white;
    font-size: clamp(22px, 4vw, 30px);
}

.input_group {
    background-color: $white;
    border-radius: $radius-pill;
    overflow: hidden;

    label {
        color: $black;
        flex: 0 0 auto;
        white-space: nowrap;
        font-size: clamp(16px, 2.2vw, 20px);
    }

    input {
        background-color: $white;
        border: none;
        flex: 1;
        min-width: 0;
        outline: none;
        border-radius: 0 $radius-pill $radius-pill 0;
        padding: 0 0px 0 20px;
        font-size: clamp(16px, 2.2vw, 20px);
    }
}

// styly pro aktivní inputy
.input_group.active label {
    transition: all 0.2s ease-in-out;
    display: none
}

.input_group.active {
    background-color: $white;
    padding: 0
}

.input_group.active input {
    width: 100%;
    opacity: 1;
    padding: 16px 20px;
    border-radius: $radius-pill;
    outline: none;
    border: none;
}

.form-check-input[type=checkbox] {
    border-radius: 50%;
    border: none;
    width: 1.2em;
    height: 1.2em;
}
</style>